import { render, staticRenderFns } from "./pageSwitch.vue?vue&type=template&id=2b63f720&scoped=true&"
import script from "./pageSwitch.vue?vue&type=script&lang=js&"
export * from "./pageSwitch.vue?vue&type=script&lang=js&"
import style0 from "./pageSwitch.vue?vue&type=style&index=0&id=2b63f720&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b63f720",
  null
  
)

export default component.exports